import React, { useEffect, useState } from 'react';
import { SlCalender } from 'react-icons/sl';
import MyCalendar from '../../Components/MyCalender';
import Captcha from '../../Components/Captcha';
import useFetchApi from '../../hooks/useFetchApi';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Instructions from '../../Components/Frontend/Instructions';
import PriceList from '../../Components/Frontend/PriceList';
import FormSelect from '../../Components/FormSelect';
import FormInput from '../../Components/FormInput';
import FormTextarea from '../../Components/FormTextarea';
import Faq from '../../Components/Frontend/Faq';
import { FRONTEND_HOME_URL } from '../../utils/Constant';

function Home() {

    const [purpose, setPurpose] = useState(false);
    const [errors, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [validateCaptchaFn, setValidateCaptchaFn] = useState(null);

    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [price, setPrice] = useState('');

    const [timer, setTimer] = useState(30);
    const [canResend, setCanResend] = useState(false);

    const [disabledDates, setDisabledDates] = useState([]);

    const navigate = useNavigate();

    // ✅ Check if user is already logged in
    const loggedInUser = JSON.parse(localStorage.getItem("user_data"));

    const [formData, setFormData] = useState({
        mandap_id: '',
        from_date: '',
        to_date: '',
        name: loggedInUser?.name || '',
        mobile: loggedInUser?.mobile_no || '',
        email: loggedInUser?.email || '',
        father_husband_name: '',
        relation: '',
        id_proof_id: '',
        id_proof_number: '',
        purpose_id: '',
        other_purpose: '',
        address: '',
    });

    // const url = 'https://orisoftpl.com/backend/api/frontend/home';
    const url = FRONTEND_HOME_URL;

    const { data: mandapData } = useFetchApi({ url, dataKey: 'mandaps' });
    const { data: purposeData } = useFetchApi({ url, dataKey: 'purposes' });
    const { data: idProofData } = useFetchApi({ url, dataKey: 'idProofs' });

    // =========================
    // ✅ Fetch user profile + last booking to pre-fill form
    // =========================
    useEffect(() => {
        const token = localStorage.getItem("user_token");
        if (!token) return;

        const fetchUserProfile = async () => {
            try {
                const res = await fetch("https://orisoftpl.com/backend/api/frontend/my-profile", {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!res.ok) return;

                const data = await res.json();
                const user = data.user;
                const lastBooking = data.lastBooking;

                console.log("Validation errors:", data); // ✅ add this

                // ✅ Update localStorage with fresh user data
                localStorage.setItem("user_data", JSON.stringify(user));

                // ✅ Pre-fill form with user + last booking data
                setFormData((prev) => ({
                    ...prev,
                    name: user.name || '',
                    mobile: user.mobile_no || '',
                    email: user.email || '',
                    father_husband_name: lastBooking?.father_husband_name || '',
                    relation: lastBooking?.relation || '',
                    id_proof_id: lastBooking?.id_proof_id || '',
                    id_proof_number: lastBooking?.id_proof_number || '',
                    address: lastBooking?.address || '',
                }));

            } catch (error) {
                console.log("Profile fetch error:", error);
            }
        };

        fetchUserProfile();
    }, []);

    // =========================
    // Disabled dates
    // =========================
    useEffect(() => {
        if (!formData.mandap_id) return;

        const fetchDisabledDates = async () => {
            try {

                const res = await fetch(
                    `https://orisoftpl.com/backend/api/frontend/booking/booked-dates/${formData.mandap_id}`
                );
                const data = await res.json();
                setDisabledDates(data.disabled_dates);
            } catch (error) {
                console.log(error);
            }
        };

        fetchDisabledDates();
    }, [formData.mandap_id]);

    // =========================
    // Timer For Otp
    // =========================
    useEffect(() => {
        let interval;

        if (otpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [otpSent, timer]);

    // =========================
    // FORMAT DATE — MM/DD/YYYY → YYYY-MM-DD
    // =========================
    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        if (dateStr instanceof Date) {
            const year = dateStr.getFullYear();
            const month = String(dateStr.getMonth() + 1).padStart(2, "0");
            const day = String(dateStr.getDate()).padStart(2, "0");

            return `${year}-${month}-${day}`;
        }

        if (typeof dateStr === "string" && dateStr.includes("/")) {
            const [month, day, year] = dateStr.split("/");

            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }

        return dateStr;
    };

    // =========================
    // VALIDATION
    // =========================
    const validateErrors = (name, value, data = {}) => {
        let error = '';
        const optionalFields = ['email', 'other_purpose'];

        if (!value && !optionalFields.includes(name)) {
            error = 'This field is required';
        }

        if (name === 'from_date' && data.to_date) {
            if (new Date(value) > new Date(data.to_date)) {
                error = 'From date must be less than To date';
            }
        }

        if (name === 'to_date' && data.from_date) {
            if (new Date(value) < new Date(data.from_date)) {
                error = 'To date must be greater than From date';
            }
        }

        if (name === 'mobile' && value) {
            if (!/^\d+$/.test(value)) {
                error = 'Mobile number must contain only digits';
            } else if (value.length !== 10) {
                error = 'Mobile number must be exactly 10 digits';
            }
        }

        if (name === 'email' && value) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                error = 'Invalid email';
            }
        }

        const idProofName = data.id_proof_id
            ? idProofData.find((item) => item.id === parseInt(data.id_proof_id))?.name
            : null;

        if (name === 'id_proof_number' && idProofName?.toLowerCase().includes('aadhaar')) {
            if (!/^\d{12}$/.test(value)) {
                error = 'Aadhaar number must be exactly 12 digits';
            }
        }

        if (name === 'id_proof_number' && idProofName?.toLowerCase().includes('pan')) {
            const pan = value.toUpperCase();
            if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(pan)) {
                error = 'Invalid PAN format (ABCDE1234F)';
            }
        }

        if (name === 'other_purpose') {
            const purposeName = purposeData.find(
                (item) => item.id === parseInt(data.purpose_id)
            )?.name;
            if (purposeName?.toLowerCase() === 'other' && !value) {
                error = 'Other purpose is required';
            }
        }

        return error;
    };

    // =========================
    // HANDLE CHANGE
    // =========================
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'purpose_id') {
            const purposeName = purposeData.find((item) => item.id === parseInt(value));
            setPurpose(purposeName?.name?.toLowerCase() === 'other');
        }

        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);

        const error = validateErrors(name, value, updatedData);
        setError((prev) => ({ ...prev, [name]: error }));
    };

    // =========================
    // FORM VALIDATE
    // =========================
    const formValidate = () => {
        const tempErrors = {};
        Object.keys(formData).forEach((key) => {
            const error = validateErrors(key, formData[key], formData);
            if (error) tempErrors[key] = error;
        });
        setError(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    // =========================
    // SUBMIT
    // =========================
    const handleSubmit = async (e) => {
        e.preventDefault();

        // =========================
        // VERIFY OTP FLOW
        // =========================
        if (otpSent) {
            if (!otp) {
                Swal.fire({ icon: 'warning', title: 'OTP Required', text: 'Please enter OTP' });
                return;
            }

            try {
                setLoading(true);

                const res = await fetch('https://orisoftpl.com/backend/api/frontend/booking/verify', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        otp,
                        ...formData,
                        from_date: formatDate(formData.from_date), // ✅ fixed
                        to_date: formatDate(formData.to_date),   // ✅ fixed
                    }),
                });

                const data = await res.json();

                if (!res.ok) {
                    Swal.fire({ icon: 'error', title: 'Invalid OTP', text: data.message });
                    return;
                }

                // ✅ Auto login after OTP verify
                if (data.token) {
                    localStorage.setItem("user_token", data.token);
                    localStorage.setItem("user_data", JSON.stringify(data.user));
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Booking Saved Successfully',
                    text: 'Redirecting to payment page',
                });

                setTimeout(() => {
                    navigate(`/payment/${data.ref_no}`);
                }, 2000);

            } catch (error) {
                Swal.fire({ icon: 'error', title: 'Server Error', text: 'Something went wrong' });
            } finally {
                setLoading(false);
            }

            return;
        }

        // =========================
        // FORM VALIDATION
        // =========================
        const isValid = formValidate();
        if (!isValid) return;

        if (validateCaptchaFn && !validateCaptchaFn()) return;

        // =========================
        // SEND OTP
        // =========================
        try {
            setLoading(true);

            const payload = {
                ...formData,
                from_date: formatDate(formData.from_date),
                to_date: formatDate(formData.to_date),
            };

            console.log("Sending payload:", payload); // ✅ check this in console

            const res = await fetch('https://orisoftpl.com/backend/api/frontend/booking', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    from_date: formatDate(formData.from_date), // ✅
                    to_date: formatDate(formData.to_date),   // ✅
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                console.log("Laravel Validation Errors:", data);

                if (data.errors) {
                    const formattedErrors = {};

                    Object.keys(data.errors).forEach((key) => {
                        formattedErrors[key] = data.errors[key][0];
                    });

                    setError(formattedErrors);
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Validation Error',
                    text: JSON.stringify(data.errors),
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'OTP Sent!',
                text: `Booking amount ₹${data.price}`,
                timer: 2500,
                showConfirmButton: false,
            });

            setOtpSent(true);
            setPrice(data.price);
            setTimer(30);
            setCanResend(false);

        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Server Error', text: 'Something went wrong' });
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // Resend Otp
    // =========================
    const handleResendOtp = async () => {
        setOtp('');
        try {
            setLoading(true);
            const res = await fetch('https://orisoftpl.com/backend/api/frontend/booking/resend-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ mobile: formData.mobile }),
            });

            const data = await res.json();

            if (!res.ok) {
                Swal.fire({ icon: 'error', title: 'Oops!', text: data.message || 'Failed to resend OTP' });
                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'OTP Resent',
                text: data.message,
                timer: 2000,
                showConfirmButton: false,
            });

            setTimer(30);
            setCanResend(false);

        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Server Error', text: 'Something went wrong' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="container mx-auto">

                    <div className="text-center flex justify-center items-center text-3xl mb-3 mt-10 text-red-900">
                        <SlCalender />
                    </div>

                    <h3 className="
                        text-3xl text-center font-bold relative pb-2 text-black
                        after:absolute after:content-[''] after:left-0 after:bottom-0
                        after:right-0 after:w-[140px] after:h-1 after:mx-auto
                        after:bg-gradient-to-br after:from-[#2f4ea2] after:to-[#00bcd4]
                        after:rounded-md
                    ">
                        Book a Mandap
                    </h3>

                    <p className='text-center mt-4'>
                        Fill in the details below to reserve your Mandap.
                    </p>

                    {/* ✅ Welcome message if logged in */}
                    {loggedInUser && (
                        <div className="w-3/5 mx-auto mt-3">
                            <div className="alert bg-green-50 border border-green-200 text-green-700 text-sm">
                                👋 Welcome back, <b>{loggedInUser.name}</b>! Your details have been pre-filled.
                            </div>
                        </div>
                    )}

                    <div className="bg-white p-6 border border-gray-200 shadow-md shadow-inner w-3/5 mx-auto mt-5">
                        <h5 className="text-xl font-bold text-black mb-4">Booking Details</h5>

                        {/* Row 1 - Mandap + Dates */}
                        <div className="grid grid-cols-4 gap-4 mb-3">
                            <div className="col-span-2">
                                <FormSelect
                                    label="Select Booking For" required
                                    name="mandap_id" value={formData.mandap_id}
                                    onChange={handleChange} disabled={otpSent}
                                    error={errors.mandap_id} options={mandapData}
                                    placeholder="Select mandap"
                                />
                            </div>
                            <div className="col-span-1">
                                <MyCalendar
                                    lable={<>From Date <span className='text-red-500 text-sm'> *</span></>}
                                    onChange={handleChange} disabled={otpSent}
                                    name='from_date' value={formData.from_date}
                                    error={errors.from_date} excludeDates={disabledDates}
                                />
                                {errors.from_date && (
                                    <p className='text-red-500 text-xs mt-1'>{errors.from_date}</p>
                                )}
                            </div>
                            <div className="col-span-1">
                                <MyCalendar
                                    lable={<>To Date <span className='text-red-500 text-sm'> *</span></>}
                                    name='to_date' onChange={handleChange} disabled={otpSent}
                                    value={formData.to_date} error={errors.to_date}
                                    excludeDates={disabledDates}
                                />
                                {errors.to_date && (
                                    <p className='text-red-500 text-xs mt-1'>{errors.to_date}</p>
                                )}
                            </div>
                        </div>

                        {/* Row 2 - Name + Mobile */}
                        <div className="grid grid-cols-2 gap-4 mb-3">
                            <FormInput
                                label="Name" required name="name"
                                value={formData.name} onChange={handleChange}
                                disabled={otpSent || !!loggedInUser}
                                error={errors.name}
                            />
                            <FormInput
                                label="Mobile" required name="mobile"
                                value={formData.mobile} onChange={handleChange}
                                disabled={otpSent || !!loggedInUser}
                                error={errors.mobile} maxLength={10}
                            />
                        </div>

                        {/* Row 3 - Email + Father/Husband */}
                        <div className="grid grid-cols-2 gap-4 mb-3">
                            <FormInput
                                label="Email" name="email"
                                value={formData.email} onChange={handleChange}
                                disabled={otpSent} error={errors.email}
                            />
                            <FormInput
                                label="Father/Husband" required name="father_husband_name"
                                value={formData.father_husband_name} onChange={handleChange}
                                disabled={otpSent} error={errors.father_husband_name}
                            />
                        </div>

                        {/* Row 4 - Relation + ID Proof */}
                        <div className="grid grid-cols-2 gap-4 mb-3">
                            <FormInput
                                label="Relation" required name="relation"
                                value={formData.relation} onChange={handleChange}
                                disabled={otpSent} error={errors.relation}
                            />
                            <FormSelect
                                label="ID Proof" required name="id_proof_id"
                                value={formData.id_proof_id} onChange={handleChange}
                                disabled={otpSent} error={errors.id_proof_id}
                                options={idProofData} placeholder="Select IdProof"
                            />
                        </div>

                        {/* Row 5 - ID Number + Purpose */}
                        <div className="grid grid-cols-2 gap-4 mb-3">
                            <FormInput
                                label="ID Number" required name="id_proof_number"
                                value={formData.id_proof_number} onChange={handleChange}
                                disabled={otpSent} error={errors.id_proof_number}
                            />
                            <FormSelect
                                label="Purpose" required name="purpose_id"
                                value={formData.purpose_id} onChange={handleChange}
                                disabled={otpSent} error={errors.purpose_id}
                                options={purposeData} placeholder="Select Purpose"
                            />
                            {purpose && (
                                <FormInput
                                    label="Other Purpose" required name="other_purpose"
                                    value={formData.other_purpose} onChange={handleChange}
                                    disabled={otpSent} error={errors.other_purpose}
                                />
                            )}
                        </div>

                        {/* Row 6 - Address */}
                        <div className="mb-3">
                            <FormTextarea
                                label="Address" required name="address"
                                value={formData.address} onChange={handleChange}
                                disabled={otpSent} error={errors.address}
                            />
                        </div>

                        {/* Captcha */}
                        {!otpSent && (
                            <Captcha onValidate={(fn) => setValidateCaptchaFn(() => fn)} />
                        )}

                        {/* OTP Section */}
                        {otpSent && (
                            <div className="mt-5 border rounded-lg p-4 bg-gray-50">
                                <h4 className="font-semibold text-lg mb-3">Verify OTP</h4>
                                <div className="mb-3">
                                    <label className="text-sm block mb-1">Booking Amount</label>
                                    <input
                                        type="text" value={`₹ ${price}`} disabled
                                        className="input input-bordered input-md w-full bg-gray-100"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">Enter OTP</label>
                                    <input
                                        type="text" value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        className="input input-bordered input-md w-full"
                                    />
                                    <div className="flex justify-between items-center mt-3">
                                        {!canResend ? (
                                            <p className="text-sm text-gray-500">
                                                Resend OTP in {timer}s
                                            </p>
                                        ) : (
                                            <button
                                                type="button" onClick={handleResendOtp}
                                                className="text-blue-600 text-sm font-medium hover:underline"
                                            >
                                                Resend OTP
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Submit Button */}
                        <div className="text-center mt-5">
                            <button
                                type="submit" disabled={loading}
                                className='text-white bg-red-600 rounded-md capitalize btn-md px-8 mt-10'
                            >
                                {loading ? 'Please wait...' : otpSent ? 'Verify OTP' : 'Book Now'}
                            </button>
                        </div>
                    </div>

                    <Instructions />
                    <PriceList />
                </div>
            </form>

            <Faq />
        </>
    );
}

export default Home;